"use client";

import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { NewBonusCardRequest } from "@components/landing/NewBonusCardRequest";
import { ActivateAccount } from "@components/landing/ActivateAccount";
import { Contact } from "@components/landing/Contact";
import { LoginCard } from "@components/landing/LoginCard";
import { useSelector, useDispatch } from "react-redux";
import { selectBrandString, selectBrandName } from "@store/features/styleSchemaSlice";
import { selectIsAuthenticated } from "@store/selectors/auth.selectors";
import { closeActivateExistingAccountModal } from "@store/features/userActionsSlice";
import { useEffect } from "react";

export default function HomePage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const brandString = useSelector(selectBrandString);
  const brand = useSelector(selectBrandName);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(closeActivateExistingAccountModal());
    }
  }, [isAuthenticated, dispatch]);

  return (
    <div className="flex flex-col pt-8 space-y-16 bg-white">
      <section className={clsx("w-full px-4")}>
        <div className="flex flex-col gap-4 justify-center items-center w-full">
          <h1 className="text-2xl font-bold">{t("root.title")}</h1>
          <p className="">{t("root.description")}</p>
          <ul className="">
            <li className="ml-2">
              <span className="mr-2 font-bold">✓</span>
              <span>{t("root.steps.step1", { brandString })}</span>
            </li>
            <li className="ml-2">
              <span className="mr-2 font-bold">✓</span>
              <span>{t("root.steps.step2")}</span>
            </li>
            <li className="ml-2">
              <span className="mr-2 font-bold">✓</span>
              <span>{t("root.steps.step3")}</span>
            </li>
          </ul>
          <NewBonusCardRequest />
          <LoginCard />
        </div>
      </section>
      {brand !== 'essanelle' && brand !== 'supercut' && brand !== 'hairexpress' && <section className="bg-white px-4">
        <div className="flex flex-col gap-4 w-full justify-center items-center">
          <h2 className="text-2xl font-bold">
            {t("root.card-allready-in-use", { brandString })}
          </h2>
          <div
            className="space-y-4 w-full max-w-3xl text-center"
            dangerouslySetInnerHTML={{
              __html: t("root.card-allready-in-use-description", { brandString }),
            }}
          />
          <ActivateAccount />
        </div>
      </section>}
      <Contact />
    </div>
  );
}
